<template>
    <component :is="col.type" :row="row" :data="col.data" @colClick="clickHandler" :component="col.component"></component>
</template>

<script>
import PlatText from "./PlatText";
import Link from "./Link";
import Custom from "./Custom";
import Checkbox from "./Checkbox";
import Radio from "./Radio";

export default {
    name: "Column",
    components: {
        PlatText,
        Link,
        Custom,
        Checkbox,
        Radio,
    },
    props: ["col", "row"],
    methods: {
        clickHandler(data) {
            data.colId = this.col.colId;
            this.$emit('colClick', data);
        }
    }
};
</script>
